import { createAsyncThunk } from "@reduxjs/toolkit";

// Login
export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async ({ username, password }, thunkAPI) => {
    const uri = `${process.env.REACT_APP_BACKEND_URL}/users/login/`;
    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    };

    try {
      const response = await fetch(uri, options);
      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        const message =
          data?.detail ||
          data?.message ||
          (typeof data === "string" ? data : null) ||
          "Error al iniciar sesión";
        throw new Error(message);
      }

      return { token: data.access, refreshToken: data.refresh, user: data.user };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Signup
export const registerUser = createAsyncThunk(
  "auth/registerUser",
  async (userData, thunkAPI) => {
    const uri = `${process.env.REACT_APP_BACKEND_URL}/users/sign-up/`;
    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(userData),
    };

    try {
      const response = await fetch(uri, options);
      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        const message =
          data?.detail ||
          data?.message ||
          (typeof data === "string" ? data : null) ||
          "Registro fallido";
        throw new Error(message);
      }

      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Activate account
export const activateAccount = createAsyncThunk(
  "auth/activateAccount",
  async ({ token, password }, thunkAPI) => {
    const uri = `${process.env.REACT_APP_BACKEND_URL}/users/activate/`;
    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, password }),
    };

    try {
      const response = await fetch(uri, options);
      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        const message =
          data?.detail ||
          data?.message ||
          (typeof data === "string" ? data : null) ||
          "No se pudo activar la cuenta";
        throw new Error(message);
      }

      return data; // { detail: "Cuenta activada correctamente." }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Update Profile
export const updateProfile = createAsyncThunk(
  "auth/updateProfile",
  async ({ formData, token }, thunkAPI) => {
    const uri = `${process.env.REACT_APP_BACKEND_URL}/users/me/update/`;
    const options = {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    };

    try {
      const response = await fetch(uri, options);
      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        const message =
          data?.detail ||
          data?.message ||
          (typeof data === "string" ? data : null) ||
          "Error al actualizar perfil";
        throw new Error(message);
      }

      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const requestPasswordReset = createAsyncThunk(
  "auth/requestPasswordReset",
  async ({ email }, thunkAPI) => {
    const uri = `${process.env.REACT_APP_BACKEND_URL}/users/password-reset/request/`;
    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    };

    try {
      const response = await fetch(uri, options);
      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        const message = data?.detail || "No se pudo enviar el email de recuperación";
        throw new Error(message);
      }

      return data; // { detail: "Si el email existe..." }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const confirmPasswordReset = createAsyncThunk(
  "auth/confirmPasswordReset",
  async ({ token, password }, thunkAPI) => {
    const uri = `${process.env.REACT_APP_BACKEND_URL}/users/password-reset/confirm/`;
    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, password }),
    };

    try {
      const response = await fetch(uri, options);
      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        const message = data?.detail || "No se pudo restablecer la contraseña";
        throw new Error(message);
      }

      return data; // { detail: "Contraseña actualizada correctamente." }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);